/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Br_History_Key_Setpointtemperatureonoccupation3Inputs */



/**
* | output |
* | --- |
* | "Setpoint temperature during occupation" |
*
* @param {Br_History_Key_Setpointtemperatureonoccupation3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const br_history_key_setpointtemperatureonoccupation3 = /** @type {((inputs?: Br_History_Key_Setpointtemperatureonoccupation3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Br_History_Key_Setpointtemperatureonoccupation3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Setpoint temperature during occupation")
	return /** @type {LocalizedString} */ ("Température de consigne en occupation")
});
export { br_history_key_setpointtemperatureonoccupation3 as "br_history_key_setpointTemperatureOnOccupation" }